var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.324,
    height: 13.486,
    viewBox: "0 0 17.324 13.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0.004 -2.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63438",
    "data-name": "Path 63438",
    d: "M16.79,7.536A9.556,9.556,0,0,0,8.657,2.655,9.556,9.556,0,0,0,.525,7.536a3.541,3.541,0,0,0,0,3.725,9.556,9.556,0,0,0,8.133,4.881A9.556,9.556,0,0,0,16.79,11.26,3.541,3.541,0,0,0,16.79,7.536ZM15.56,10.5a8.164,8.164,0,0,1-6.9,4.193,8.164,8.164,0,0,1-6.9-4.193,2.105,2.105,0,0,1,0-2.214A8.164,8.164,0,0,1,8.657,4.1a8.158,8.158,0,0,1,6.9,4.193A2.105,2.105,0,0,1,15.56,10.5Z",
    transform: "translate(0)",
    fill: "#575b73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63439",
    "data-name": "Path 63439",
    d: "M10.608,7a3.608,3.608,0,1,0,3.608,3.608A3.608,3.608,0,0,0,10.608,7Zm0,5.772a2.165,2.165,0,1,1,2.165-2.165A2.165,2.165,0,0,1,10.608,12.772Z",
    transform: "translate(-1.95 -1.21)",
    fill: "#575b73"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeIcon);
export default __webpack_public_path__ + "static/media/password-eye-icon.83b671479d2c9d96a0259ba26286dbc7.svg";
export { ForwardRef as ReactComponent };